import React from "react";
import { Typography } from "@icecreamsocial/components";
import { useIntl } from "react-intl";

type PrivacyStatementProps = {
  privacyURL: string;
};

export const PrivacyStatement = ({ privacyURL }: PrivacyStatementProps) => {
  const intl = useIntl();

  const CONSENT_POLICY_EXPLANATION = intl.formatMessage(
    {
      id: "unlock.consentPolicyExplanation",
      defaultMessage: `
			We protect your data with care, just as described in our <linkText>Privacy Policy</linkText>
		`,
      description:
        "Explanation text that presents a link to the client's privacy policy"
    },
    {
      linkText: str => (
        <Typography.A href={privacyURL} target="_blank" visitedTextColor="link">
          {str}
        </Typography.A>
      )
    }
  );

  return (
    <Typography.P typoSize=".8em">{CONSENT_POLICY_EXPLANATION}</Typography.P>
  );
};
